import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData } from "src/utils/axios/serverHelper";
import { PDA1020_R01Dto, PDA1020_R01Filter } from "./PDA1020_R01Dto";

const baseUrl = `${config.apiUrl}/PDA1020_R01`;

export const getPDA1020_R01List = async (filter: PDA1020_R01Filter) => {
  return getData<ResponseDto<PDA1020_R01Dto[]>>(`${baseUrl}/search`, {
    params: {
      compCd: filter.compCd,
      startDate: filter.startDate,
      endDate: filter.endDate,
    },
  });
};
